import { ReactNode } from "react";
import { RenderWhen } from "../../../../components";
import RLCard from "../../../../components/card/RLCard";
import NetworkThreatError from "../common/NetworkThreatError";
import NetworkThreatHeaderLink from "../common/NetworkThreatHeaderLink";
import PageIdNavigation from "../common/PageIdNavigation";
import TableHeader from "../common/TableHeader";
import TableHeaderNavigation from "../common/TableHeaderNavigation";
import styles from "../network-threat.module.scss";

interface Props {
  id?: string;
  width?: "full" | "half";
  header: ReactNode;
  content: ReactNode;
  contentClassName?: string;
  errorComp?: ReactNode;
  showError?: boolean;
}

const WIDTH = {
  full: styles.full_width,
  half: styles.half_width
};

function NetworkThreatCard({
  id,
  header,
  content,
  contentClassName,
  errorComp,
  showError = false,
  width = "half"
}: Props) {
  return (
    <RLCard
      id={id}
      className={`network-threat-intel__content-row-item ${WIDTH[width]} ${styles.network_threat_card}`}
      header={header}
      content={
        <RLCard.Content className={contentClassName}>
          <RenderWhen condition={!showError} fallback={errorComp}>
            {content}
          </RenderWhen>
        </RLCard.Content>
      }
    />
  );
}

NetworkThreatCard.Header = TableHeader;
NetworkThreatCard.HeaderNavigation = TableHeaderNavigation;
NetworkThreatCard.PageIdNavigation = PageIdNavigation;
NetworkThreatCard.Error = NetworkThreatError;
NetworkThreatCard.HeaderLink = NetworkThreatHeaderLink;
export default NetworkThreatCard;
